<template>
  <div class="m-confirm" v-if="visible">
    <div class="mask" :class="{ on: shown }" @click="cancel"></div>
    <div class="dialog" :class="{ on: shown }">
      <div class="dt">{{ title }}</div>
      <div class="dc">{{ content }}</div>
      <div class="db">
        <button type="button" @click="cancel" :disabled="cancelDisabled">{{ cancelText }}</button>
        <button type="button" class="ok" @click="ok" :disabled="okDisabled">{{ okText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 移动端确认弹窗（样式与原型 index.html 的 .dialog / .mask 一致）
 * 用法：<m-confirm :visible.sync="show" title="退出登录" content="确认退出当前账号？"
 *        okText="退出" @ok="doLogout" @cancel="show=false" />
 */
export default {
  name: 'MConfirm',
  props: {
    visible: {type: Boolean, default: false},
    title: {type: String, default: ''},
    content: {type: String, default: ''},
    okText: {type: String, default: '确定'},
    cancelText: {type: String, default: '取消'},
    okDisabled: {type: Boolean, default: false},
    cancelDisabled: {type: Boolean, default: false}
  },
  data() {
    return {
      shown: false
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.shown = true
          })
        })
      } else {
        this.shown = false
      }
    }
  },
  mounted() {
    if (this.visible) {
      requestAnimationFrame(() => {
        this.shown = true
      })
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    ok() {
      if (this.okDisabled) return
      this.$emit('update:visible', false)
      this.$emit('ok')
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.m-confirm {
  --danger: #f5544b;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(12, 16, 22, .45);
  opacity: 0;
  visibility: hidden;
  transition: .25s;
  z-index: 50
}

.mask.on {
  opacity: 1;
  visibility: visible
}

.dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(.88);
  width: 272px;
  background: #fff;
  border-radius: 14px;
  z-index: 70;
  opacity: 0;
  visibility: hidden;
  transition: .2s;
  overflow: hidden;
  text-align: center
}

.dialog.on {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, -50%) scale(1)
}

.dt {
  font-size: 16px;
  font-weight: 600;
  color: var(--t1);
  padding: 22px 20px 0
}

.dc {
  font-size: 13.5px;
  color: var(--t2);
  padding: 10px 20px 20px;
  line-height: 1.6
}

.db {
  display: flex;
  border-top: 1px solid var(--line)
}

.db button {
  flex: 1;
  height: 46px;
  font-size: 16px;
  color: var(--t2);
  border: none;
  background: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent
}

.db button:active {
  background: #f6f7f9
}

.db button.ok {
  color: var(--danger);
  font-weight: 600;
  border-left: 1px solid var(--line)
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MConfirm.vue